import gql from 'graphql-tag'

export const GetPatient = gql`
  query GetPatient($id: MongoID!) {
    getPatient(id: $id) {
      _id
      data {
        name {
          first
          last
          display
        }
        profile_photo {
          _id
          url
        }
        dob
        gender
        address {
          street
          city
          state
          zip
        }
        address_billing {
          street
          city
          state
          zip
        }
        address_shipping {
          street
          city
          state
          zip
        }
        race {
          _id
          name
          value
          value2
        }
        ethnicity {
          _id
          name
          value
          value2
        }
        phones {
          number
          type
        }
        emails {
          address
        }
      }
      partner {
        _id
      }
    }
  }
`

export const ListPatients = gql`
  query ListPatients($page: NonNegativeInt = 1, $limit: PositiveInt = 20, $filter: PatientFilter, $sort: PatientSort) {
    listPatients(page: $page, limit: $limit, filter: $filter, sort: $sort) {
      page
      pages
      total
      patients {
        _id
        data {
          name {
            first
            last
            display
          }
          profile_photo {
            _id
            url
          }
        }
      }
    }
  }
`
